import { api } from 'API';
import { FileCategories } from 'Enum';

export enum FileTypeError {
  ErrorUnclearDocument = 2,
  ErrorIncomleteDocument = 3,
  ErrorMismatchType = 4,
  ErrorIdentificationDetails = 5,
  ServiceUnavailable = 6,
  UnknownError = 7,
}

const baseUrl = '/file';
type base64 = string;

interface IFileBase64 {
  contentType: string;
  fileContentBase64: base64;
}
export const getFile = async (id: number, fileName: string) => {
  const fileData = await api.get<IFileBase64>(baseUrl + '/' + id);
  if (fileData.data) {
    const byteCharacters = atob(fileData.data.fileContentBase64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new File([byteArray], fileName, {
      type: fileData.data.contentType,
    });
  }
};

export interface IFile {
  caseDetailsRelationId?: number;
  fileCategoryRelationId: number;
  fileCategoryName: string;
  id: number;
  userGivenName: string;
  hospitalizationDetailsRelationId?: number;
  witnessId?: number;
  isAnalysisOccured: boolean;
  isAnalysisSucceeded?: boolean;
  analysisErrorCode?: number;
  displayErrorText?: string;
}

export type fileNames = Partial<Record<FileCategories, IFile[]>>;

export type fileName = {
  fileCategoryRelationId: number;
  id: number;
  isAnalysisOccured: boolean;
  userGivenName: string;
};

export const getFileNames = async () => {
  const fileNamesData = await api.get<fileNames>(`${baseUrl}/fileNames`);
  if (fileNamesData.data) {
    return fileNamesData.data;
  }
};

export const getFileName = async (fileId: number) => {
  const fileNameData = await api.get<fileName>(
    `${baseUrl}/fileNames/${fileId}`
  );
  if (fileNameData.data) {
    return fileNameData.data;
  }
};

export const postFile = async (
  fileCategoryId: number,
  file: FormData,
  caseDetailsId?: number,
  witnessId?: number,
  hospitalizationDetailsId?: number
) => {
  const caseDetailsKeyName = 'caseDetailsId';
  const witnessKeyName = 'WitnessId';
  const hospitalizationDetailsKeyName = 'hospitalizationDetailsId';

  let url = baseUrl + '/' + fileCategoryId;
  if (caseDetailsId || hospitalizationDetailsId) {
    url += '?';
  }
  if (caseDetailsId) {
    url += `${caseDetailsKeyName}=${caseDetailsId}`;
  }
  if (witnessId) {
    url += `&${witnessKeyName}=${witnessId}`;
  }
  if (hospitalizationDetailsId) {
    url += `&${hospitalizationDetailsKeyName}=${hospitalizationDetailsId}`;
  }

  const fileData = await api.post<IFile>(url, file);
  if (fileData.data) {
    return fileData.data;
  }
};

export const deleteFile = async (id: number) => {
  const fileData = await api.delete(baseUrl + '/' + id);
  if (fileData.status === 200) {
    return true;
  }
  return false;
};
